import axios from 'axios';

const baseURL = {
development: 'https://1woozwf2bh.execute-api.ap-south-1.amazonaws.com/dev/pop',
production: 'https://e0ts8ik4id.execute-api.ap-south-1.amazonaws.com/prod/pop/'
}


export default axios.create({ baseURL: baseURL[process.env.REACT_APP_ENV || 'production'] });